import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Dumb as Atoms } from '../atoms';
import * as Organisms from '../organisms';
import * as Molecules from '../molecules';
import { getLoadingStateIndex, isIndexFailed } from '../../utils/loading';
import { FOOTER_HEIGHT } from '../const';
import { isActive } from '../../featureswitches/Features';
import { glassboxWebJs } from '@prezi/client-logger-module';
const Container = styled.div.withConfig({
  displayName: "SharePage__Container",
  componentId: "nb55xq-0"
})(["display:flex;flex-direction:column;", " padding-bottom:", "px;"], p => p.increasePadding ? `padding: 24px;` : `padding: 16px;`, FOOTER_HEIGHT);
const Grid = styled(Atoms.RowGrid).withConfig({
  displayName: "SharePage__Grid",
  componentId: "nb55xq-1"
})(["padding-bottom:16px;"]);
const SharePage = () => {
  const [prevLoadingStateIndex, setPrevLoadingStateIndex] = React.useState(-1);
  const [hasFailed, setHasFailed] = React.useState(false);
  const asyncValues = useSelector(state => [state.unifiedPrivacy, state.userPermissions, state.collaborators, state.document, state.viewlinks]);
  const loadingStateIndex = getLoadingStateIndex(asyncValues);
  const isLoading = loadingStateIndex !== -1;
  const isShareLinkImprovementsActive = isActive('gm-share-modal-share-link-improvements');
  React.useEffect(() => {
    if (isLoading) {
      setPrevLoadingStateIndex(loadingStateIndex);
      setHasFailed(false);
    } else {
      if (isIndexFailed(asyncValues, prevLoadingStateIndex)) {
        setHasFailed(true);
      } else {
        if (isActive('gm-abtest-share-modal-share-link-improvements')) {
          glassboxWebJs.logEnteredAbTestExperience({
            ab_test_name: 'gm-abtest-share-modal-share-link-improvements'
          });
        }
      }
    }
  }, [loadingStateIndex]);
  return React.createElement(Container, {
    increasePadding: isShareLinkImprovementsActive
  }, React.createElement(Organisms.Dumb.Header, {
    hasReducedPadding: isShareLinkImprovementsActive,
    isLoading: isLoading,
    hasError: hasFailed
  }), React.createElement(Grid, {
    rowGap: Atoms.RowGap.small
  }, React.createElement(Molecules.Smart.ViewLinkCopy, {
    isShareLinkImprovementsActive: isShareLinkImprovementsActive
  }), React.createElement(Molecules.Smart.TrackableLinksOverview, {
    isShareLinkImprovementsActive: isShareLinkImprovementsActive
  }), React.createElement(Atoms.SimpleDivider, null), React.createElement(Organisms.Smart.IndividualAccess, null), React.createElement(Organisms.Smart.DocumentSettings, {
    hasExtraBottomPadding: isShareLinkImprovementsActive
  })), React.createElement(Organisms.Smart.Footer, {
    hasIncreasedPadding: isShareLinkImprovementsActive
  }));
};
export default SharePage;